"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextDocumentElement = void 0;
const react_1 = __importStar(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const react_redux_1 = require("react-redux");
const react_quill_1 = __importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
require("./style.scss");
const constants_1 = require("../../../../../../constants/constants");
const useSearchDebounce_1 = require("../../../../../../hooks/useSearchDebounce");
const update_single_element_thunk_1 = require("../../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
var __value = "Start writing v--";
const type = "Text";
const quilModules = {
    toolbar: {
        container: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: ["", "center", "right"] }],
            ["clean"],
            [{ color: ["white", "black", "yellow", "green", "blue", "orange"] }, { background: ["white", "black", "yellow", "green", "blue", "orange"] }],
        ],
    },
};
exports.TextDocumentElement = {
    type,
    sideBarComponent: SideBarComponent,
    documentComponent: DocumentComponent,
    propertiesComponent: () => react_1.default.createElement("div", null, "Properties Components"),
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            extra_attributes: {
                text: "Text goes here...",
                size: 2,
                weight: 3,
                edit_type: "block",
                align: "text-start",
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faT,
        label: "Text",
    },
};
function DocumentComponent({ elementInstance }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const dispatch = (0, react_redux_1.useDispatch)();
    const editor = (0, react_1.useRef)(null);
    const [showEdit, setShowEdit] = (0, react_1.useState)(false);
    const [value, setValue] = (0, useSearchDebounce_1.useSearchDebounce)();
    const { selectedDocument, selectedDocumentElements, onDrag, selectedElementID, documentState } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    const stateCheck = documentState === constants_1.TYPE_LINK || documentState === constants_1.TYPE_PREVIEW;
    const config = {
        readonly: false,
        with: 200,
        height: 100,
    };
    const handleUpdate = (v) => {
        setValue(v);
    };
    (0, react_1.useEffect)(() => {
        if (value) {
            dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                data: {
                    document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                    payload: Object.assign(Object.assign({}, _element), { extra_attributes: {
                            text: value,
                            lock: false,
                            x: 0,
                            y: 0,
                        } }),
                },
            }));
        }
    }, [value]);
    // Check if this text element contains only an image (likely a PDF page background)
    const textContent = ((_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.text) || "";
    const isImageOnly = textContent.trim().startsWith("<img") ||
        (textContent.trim().startsWith("<p>") && textContent.includes("<img") && !textContent.replace(/<img[^>]*>/g, "").replace(/<\/?p>/g, "").trim());
    return (react_1.default.createElement("div", { className: `cursor-text --text ${isImageOnly ? "w-full h-full" : ""}`, style: isImageOnly ? { width: "100%", height: "100%" } : undefined }, selectedElementID === (_element === null || _element === void 0 ? void 0 : _element._id) && !stateCheck && !((_c = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _c === void 0 ? void 0 : _c.lock) && !onDrag ? (react_1.default.createElement("div", null,
        react_1.default.createElement(react_quill_1.default, { theme: "snow", defaultValue: `<div class="${(_d = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _d === void 0 ? void 0 : _d.align}">${(_e = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _e === void 0 ? void 0 : _e.text}</div>`, onChange: handleUpdate, modules: quilModules }))) : (react_1.default.createElement("div", { className: `${(_f = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _f === void 0 ? void 0 : _f.align} quill-content ${isImageOnly ? "w-full h-full" : ""}`, style: isImageOnly ? { width: "100%", height: "100%" } : undefined, dangerouslySetInnerHTML: { __html: (_g = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _g === void 0 ? void 0 : _g.text } }))));
}
function SideBarComponent({ elementInstance }) {
    var _a, _b, _c;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocumentElements, selectedDocument } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    const [align, setAlign] = (0, react_1.useState)((_b = _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.align);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { checkedColor: "text-secondary", uncheckedColor: "text-secondary", label: "Lock", value: (_c = _element.extra_attributes) === null || _c === void 0 ? void 0 : _c.lock, onChange: (checked) => {
                    dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                        data: {
                            document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                            payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { align: align, lock: checked }) }),
                        },
                    }));
                } }))));
}
